module.exports = __webpack_public_path__ + "static/media/side_gigs.468ded48.webp";